import {
    PencilAltIcon,
    CalendarIcon,
} from '@heroicons/react/outline'
import { BadgeCheckIcon, ChevronRightIcon } from '@heroicons/react/solid'
import Image from 'next/image'
import Link from 'next/link'
import { useState } from 'react'
import { cloudfront } from "../../config";
import bizStyles from '../../styles/Business.module.css'
import Layout from '../../components/Layouts/businessLayout'
import AlertTemplate from '../../components/Notification'
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import { useAuth, AuthProvider } from '../../contexts/Auth'
import Calendar from '../../components/Gthr/Scheduler/Utils/Calendar'
import { supabase } from '../../utils/supabaseClient'
import Meta from "../../components/Meta"
import * as ga from '../../lib/gtag'
import { useRouter } from 'next/router'
const navigation = [
  ]

export default function Network() {
    let tz = Intl.DateTimeFormat().resolvedOptions().timeZone ? Intl.DateTimeFormat().resolvedOptions().timeZone : "America/Los_Angeles"
    const [subPage, setSubPage] = useState(0)
    const [submitted, setSubmitted] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [ checkUser, setCheckUser] = useState(true)
    const [meeting, setMeeting] = useState({"name": "", "person":"", "email": "", "notes": "", "dateStr": null, "rand": (Math.random() + 1).toString(36).substring(7), "client_profile_id": null,
    "appointment_datetime": null, "client_user_id":null, "timezone":tz, "meeting_dates": [] })
    const [form, setForm] = useState({
        name: "",
        email: "",
        account_type:"marketplace",
        password:"",
        confirm_password:"",
    })
    const router = useRouter()
    const { user, signOut } = useAuth()

    const handleFormChange = (e) => {
        let newForm = { ...form }
        if (e.target) {
            newForm[e.target.name] = e.target.value
            setForm(newForm)
        }
    }

    const handleChange = (e) => {
        let newMeeting = { ...meeting }
        if (e.target) {
            newMeeting[e.target.name] = e.target.value
            setMeeting(newMeeting)
        }
    }

    const handleTimeChange = (newValue) => {
        let newMeeting = { ...meeting }
        newMeeting.timezone = newValue.value
        setMeeting(newMeeting)
    }

    const handleDateStr = (dateTime) => {
        let newMeeting = { ...meeting }
        newMeeting["dateStr"] = dateTime.toFormat('DD')
        newMeeting["appointment_datetime"] = dateTime.toISO()
        setMeeting(newMeeting)
    }
    const handleUser = (userData) => {
        let newMeeting = {...meeting}
        newMeeting.email = userData.email
        newMeeting.name = userData.name
        newMeeting.client_user_id = userData.id
        newMeeting.client_profile_id = userData.profile_id
        setMeeting(newMeeting)
      }

    const checkErrors = () => {
        if (form.password !== form.confirm_password) {
            let newError = {...error}
            newError= "Passwords do not match"
            setError(newError)
            return false
        }
        if (form.password.length < 8) {
          let newError = {...error}
          newError = "Password too short"
          setError(newError)
            return false
        } 
        if (!form.name || !form.email) {
          let newError = {...error}
          newError = "Please enter a username and email"
          setError(newError)
          return false
        }

        return true
    }
    

    const submitRegister = async (e) => {
        e.preventDefault()
        setLoading(true)

        const bool = checkErrors()
        if (!bool) {
            setLoading(false)
            return
        }

        const { user, error } = await supabase.auth.signUp({
            email: form.email,
            password: form.password,
          })


        if (!error) {
            ga.event({
              action:'user_register',
            })

            const rand = (Math.random() + 1).toString(36).substring(7)
            const profile = await supabase
                .from("main_profile")
                .insert({user_id:user.id, name:form.name, account_type:form.account_type, email: form.email, unique_slug: rand, timezone: tz })
            
     
            //send email 
            await fetch("/api/contact/register", {
              method: "POST",
              headers: {'Content-Type': 'application/json'},
              body:JSON.stringify({
                email: form.email,
                marketplace:true
              })
            })
         
            //push to stripe subscription ?? 
            router.push(`/network/onboarding`)
            // route.push(`/stripe/subscribe?step=plans`)
           
            
        } else {
            setEmailError(error.message)
        }
    }
   




    return (
        <div className="relative overflow-hidden">
            <Meta
                title="Plaza Advertising Network"
                description="The Plaza advertising network connects virtual coaches and consultants to thrid-party publishers to help coaches receive clients"

            />

            <main>
                <section className="pt-10 bg-slate-200/50 -mt-0 sm:pt-10 lg:pt-0 lg:pb-14 lg:overflow-hidden mb-2 sm:mb-40 md:mb-40 lg:mb-0">
                    <div className="mx-auto max-w-7xl lg:px-8">
                        <div className="lg:grid lg:grid-cols-2 lg:gap-8">
                            <div className="mx-auto h-full max-w-md px-4 sm:max-w-2xl sm:px-6 sm:text-center lg:px-0 lg:text-left lg:flex lg:items-center">
                                <div className="lg:py-12">
                                    {/* <a
                      href="#"
                      className="inline-flex items-center text-white bg-black rounded-full p-1 pr-2 sm:text-base lg:text-sm xl:text-base hover:text-gray-200"
                    >
                      <span className="px-3 py-0.5 text-white text-xs font-semibold leading-5 uppercase tracking-wide bg-fuchsia-700 rounded-full">
                        Beta
                      </span>
                      <span className="ml-4 text-sm">We just launched!</span>
                      <ChevronRightIcon className="ml-2 w-5 h-5 text-gray-600" aria-hidden="true" />
                    </a> */}     <div className='mt-1'><span className='text-fuchsia-700 bg-fuchsia-100 px-2 py-1 rounded-lg'>New</span></div>
                                    <h1 className="mt-4 text-5xl tracking-tight font-extrabold mb-10 text-black sm:mt-5 sm:text-6xl lg:mt-2 xl:text-5xl">
                                        <span className="block ">Focus on <span className="text-fuchsia-600"> coaching</span></span>
                                        <span className="block ">not<span className="underline decoration-fuchsia-600 decoration-wavy decoration-4"> marketing </span></span>
                                    </h1>
                                    <div className="blur-3xl  -ml-10  absolute h-32 w-32 -z-10 bg-fuchsia-500" />

                                    <p className="mt-3 text-base text-gray-700 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                                        Plaza&apos;s online marketplace helps certified coaches find clients at a price point that makes sense. 

                                    </p>
                                    <div className="">
                                            <div className="w-full mt-8 mb-10 lg:mb-0 sm:w-1/2 mx-auto lg:mx-0 md:w-1/3">
                                                <a
                                                    href={"#bookDemo"}
                                                    className="block w-full py-3 text-center px-4 rounded-md hover:text-gray-900 shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700 text-white font-medium hover:bg-fuchsia-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 focus:ring-offset-gray-900"
                                                >
                                                Book Demo
                                                </a>
                                            </div>
                                      
                                    </div>
                                </div>
                            </div>
                            <div className=" lg:pt-20 -mb-16 sm:-mb-48 lg:m-0 lg:relative">

                                <div className="blur-3xl mt-20 -ml-10 right-0 absolute h-32 w-32 -z-10 bg-fuchsia-500" />
                                <div className='my-auto mx-auto'>
                                <svg
          className=" invisible sm:visible absolute mx-auto pl-20 -z-10 transform  -translate-y-1/2"
          width={404}
          height={784}
          fill="none"
          viewBox="0 0 404 784"
          aria-hidden="true"
        >
          <defs>
            <pattern
              id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7"
              x={0}
              y={0}
              width={20}
              height={20}
              patternUnits="userSpaceOnUse"
            >
              <rect x={0} y={0} width={4} height={4} className="text-gray-300" fill="currentColor" />
            </pattern>
          </defs>
          <rect width={404} height={784} fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)" />
        </svg>
                                <div className='flex flex-row justify-center space-y-1 mx-auto sm:mx-0'>
                                        <div className="blur-3xl  -ml-10 flex flex-row   absolute h-32 w-32 -z-10 bg-fuchsia-500"/>
                                        <div className='w-60 h-60 mr-3 -mb-5 overflow-hidden'>
                                        <video autoPlay loop muted className='rounded-xl w-30 h-32 object-cover object-top shadow-lg'>
                                        <source src={`${cloudfront}/media/stock_videos/video-chat-woman-talk.mp4`} type="video/mp4" />
                                        </video>
                
                                        </div>
                                        <div className='w-60 h-60 mb-3 mr-3 sm:pt-32'>
                                        <video autoPlay loop muted className='rounded-xl w-30 h-32 object-cover shadow-lg' >
                                        <source src={`${cloudfront}/media/stock_videos/video-chat-manager.mp4`} type="video/mp4" />
                                        </video>

                                        </div>
                                </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                {/* More main page content here... */}
                <section className="relative  pt-16 pb-32 overflow-hidden">
                    <div className="">
                        <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
                            <div className="px-4 max-w-xl mx-auto sm:px-6 lg:py-32 lg:max-w-none lg:mx-0 lg:px-0 lg:col-start-2">
                                <div>
                                    <div className='z-20 relative'>
                                        <span className="h-12 w-12 rounded-md flex items-center justify-center bg-fuchsia-700">
                                            <CalendarIcon className="h-6 w-6 text-white" aria-hidden="true" />
                                        </span>
                                    </div>
                                    <div className="mt-6 z-20 relative">
                                        <h2 className="text-3xl font-extrabold tracking-tight text-gray-900">
                                            Who is this for?
                                        </h2>
                                        <p className="mt-4 text-lg text-gray-500">
                                            You are a certified coach whose clients are primarily professionals such as physicians, therapists, lawyers, or engineers.  
                                            You want to fill empty time slots in your calendar with more clients, but do not want to commit to expensive marketing initiatives
                                        </p>

                                    </div>
                                </div>
                            </div>
                            <div className="mt-12 sm:mt-16 lg:mt-0 lg:col-start-1 flex items-center  ">
                                <div className="pl-4 -mr-48 sm:pl-6 md:mr-16 lg:px-0 my-auto img-cont z-10" >
                                    <Image
                                        className={bizStyles.editorMockup }
                                        src={`${cloudfront}/static/marketplace_listings.png`}
                                        width={1474}
                                        height={1005}
                                        objectFit={"contain"}
                                        alt="Plaza for video consultations"

                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="relative mt-24">
                        <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
                            <div className="px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
                                <div>
                                    <div>
                                        <span className="h-12 w-12 rounded-md flex items-center justify-center bg-fuchsia-700">
                                            <PencilAltIcon className="h-6 w-6 text-white" aria-hidden="true" />
                                        </span>
                                    </div>
                                    <div className="mt-6 mr-10">
                                        {/* <h2 className="text-3xl font-extrabold tracking-tight text-gray-900">
                            Better understand your customers
                        </h2> */}
                                        <h2 className="text-3xl font-extrabold tracking-tight text-gray-900">
                                            How it Works
                                        </h2>
                                        <p className="mt-4 text-lg text-gray-500 relative z-20">Coaches can select how they are charged on the marketplace.  Whether coaches select per lead, per discovery call, or a flat fee of their 
                                        total coaching package, there is no long term commitment and plenty of flexibility to find the cost that works for coaches
                                        </p>
                                        <div className="mt-6"> 
                                            <a
                                                href="#bookDemo"
                                                className="inline-flex px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-fuchsia-700 hover:bg-indigo-700"
                                            >
                                                Get started
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="mt-8 border-t border-gray-200 pt-6">
                    <blockquote>
                        <div>
                        <p className="text-base text-gray-500">
                            &ldquo;Cras velit quis eros eget rhoncus lacus ultrices sed diam. Sit orci risus aenean curabitur
                            donec aliquet. Mi venenatis in euismod ut.&rdquo;
                        </p>
                        </div>
                        <footer className="mt-3">
                        <div className="flex items-center space-x-3">
                            <div className="flex-shrink-0">
                            <img
                                className="h-6 w-6 rounded-full"
                                src="https://images.unsplash.com/photo-1509783236416-c9ad59bae472?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80"
                                alt=""
                            />
                            </div>
                            <div className="text-base font-medium text-gray-700">Marcia Hill, Digital Marketing Manager</div>
                        </div>
                        </footer>
                    </blockquote>
                    </div> */}
                            </div>
                            <div className="mt-32 sm:mt-16 lg:mt-0 flex items-center ">
                                <div className="pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 img-cont" >
                                    <Image
                                       className='scale-150'
                                        src={`${cloudfront}/static/marketplace_options.png`}
                                        width={1600}
                                        height={700}
                                        objectFit={"contain"}
                                        alt="Plaza for video consultations"

                                    />
                                </div>
                            </div>
                        </div>
                    </div>
             

                </section>



                <div className="py-16 bg-slate-200/50 overflow-hidden lg:py-24">
                    <div className="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
                        <svg
                            className="hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/4"
                            width={404}
                            height={784}
                            fill="none"
                            viewBox="0 0 404 784"
                            aria-hidden="true"
                        >
                            <defs>
                                <pattern
                                    id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7"
                                    x={0}
                                    y={0}
                                    width={20}
                                    height={20}
                                    patternUnits="userSpaceOnUse"
                                >
                                    <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                                </pattern>
                            </defs>
                            <rect width={404} height={784} fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)" />
                        </svg>

                        <div className="blur-3xl  ml-10  absolute h-32 w-32 -z-10 bg-fuchsia-400" />

                        <div className="relative" id="#register">
                            <h2 className="text-center text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                                Register
                            </h2>
                            <div className="w-full lg:w-1/2 mx-auto mt-10 sm:mt-12" id="waitlist">
                                        {!submitted ?
                                            <form action="#" className="sm:max-w-xl sm:mx-auto lg:mx-0">
                                                <div className="sm:flex">
                                                    <div className="min-w-0 flex-1 space-y-4">
                                
                                                        <input
                                                            name="name"
                                                            defaultValue={form.name}
                                                            onChange={handleFormChange}
                                                            placeholder="Enter your name"
                                                            className="block w-full px-4 py-3 rounded-md border-0 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-600 "
                                                        />
                                                        <input
                                                            name="email"
                                                            defaultValue={form.email}
                                                            onChange={handleFormChange}
                                                            placeholder="Enter your email"
                                                            className="block w-full px-4 py-3 rounded-md border-0 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-600"
                                                        />
                                                       
                                                           <input
                                                            name="password"
                                                            type="password"
                                                            defaultValue={form.password}
                                                            onChange={handleFormChange}
                                                            placeholder="Enter password"
                                                            className="block w-full px-4 py-3 rounded-md border-0 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-600"
                                                        />
                                                          <input
                                                            name="confirm_password"
                                                            type="password"
                                                            defaultValue={form.confirm_password}
                                                            onChange={handleFormChange}
                                                            placeholder="Confirm your password"
                                                            className="block w-full px-4 py-3 rounded-md border-0 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-600"
                                                        />
                                                        {error && 
                                                            <p className='text-red-600'>{error}</p>
                                                        }
                                                    </div>
        
                                                </div>
                                                <div className="mt-6">
                                                        <button
                                                            onClick={submitRegister}
                                                            className="block w-full py-3 px-4 rounded-md hover:text-gray-900 shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700 text-white font-medium hover:bg-fuchsia-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 focus:ring-offset-gray-900"
                                                        >
                                                            {loading ? <div className="flex justify-center">
                                                                <svg className="animate-spin h-5 w-5 my-auto text-zinc-200 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                                </svg>
                                                            </div> : "Register"}
                                                        </button>
                                                    </div>
                                                <p className="mt-3 text-sm text-center text-gray-600 sm:mt-4">
                                                    {/* Start your free 14-day trial, no credit card necessary.*/} By providing your email, you agree to
                                                    our{' '}
                                                    <Link href="/terms-conditions">
                                                        <a className="font-medium text-gray-900">
                                                            terms of service
                                                        </a>
                                                    </Link>
                                                    .
                                                </p>
                                            </form>
                                            :
                                            submitted &&
                                            <div className="flex items-center justify-center ">
                                                <BadgeCheckIcon className="text-green-600 h-7 w-7 mr-3" /> <div>Thanks for joining.  We&apos;ll follow-up in the upcoming weeks.</div>
                                            </div>
                                        }

                                    </div>


                        </div>
                        <div className="blur-3xl right-0 mr-48 absolute h-32 w-48 -z-10 bg-fuchsia-400" />
                        <div className="relative" id="bookDemo">
                        <div className="min-h-full flex flex-col justify-center mt-48 py-12 sm:px-6 lg:px-8">
                            <div className=" sm:mx-auto sm:w-full sm:max-w-3xl">
                                <h2 className="text-center text-3xl mb-16 leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                                Book a Demo
                                </h2>
                                <div className="bg-white  w-full shadow-xl sm:rounded-lg ">
                                <Calendar
                                    meeting={meeting}
                                    handleChange={handleChange}
                                    handleDateStr={handleDateStr}
                                    handleTimeChange={handleTimeChange}
                                    handleUser={handleUser}
                                    subPage={subPage}
                                    setSubPage={setSubPage}
                                    setMeeting={setMeeting}
                                    business={true}
                                    activity={null}
                                    setCheckUser={setCheckUser}
                                    checkUser={checkUser}
                                    slug={"6vto"}
                                    
                                    />
                                </div>
                                </div>
                            </div>
                        </div>
         





                    </div>
                    <div className=''>

                        <br /> <br /> <br /> <br /> <br /> <br />
                        <p className="text-center">
                            <Link href="/terms-conditions" prefetch={false}>
                                <a > Terms & Conditions | </a>
                            </Link>
                            <Link href="/cookie-policy" prefetch={false}>
                                <a> Cookie Policy | </a>
                            </Link>
                            <Link href="/privacy-policy" prefetch={false} ><a>Privacy Policy</a></Link>
                        </p>
                        {/* <p className="text-center">
    <Link href="/contact" passhref>
        <Button variant="outline-purple" size="sm" className={footerStyles.no_sell_link}>Do Not Sell My Info</Button>
    </Link>
</p> */}
                        <p className="text-center text-gray-400">© 2023 Ordinary Media, LLC. All Rights Reserved.</p>
                    </div>
                </div>


            </main>

            <style jsx global>{`
         .img-cont > span {
          overflow:visible !important;
         }

         body {
            overlfow
         }

        `}</style>
        </div>



    )
}


const alertOptions = {
    // you can also just use 'bottom right'
    position: positions.BOTTOM_RIGHT,
    timeout: 3000,
    offset: '10px',
    containerStyle: { 'zIndex': '9999' },
    // you can also just use 'fade'
    transition: transitions.FADE,
}

Network.getLayout = function getLayout(page) {
    return (
        <AlertProvider template={AlertTemplate} {...alertOptions}>
            <AuthProvider>
                <Layout>
                    {page}
                </Layout>
            </AuthProvider>
        </AlertProvider>
    )
}


